// extracted by mini-css-extract-plugin
module.exports = {"medianText":"RtTwgu7f","medianTextPositive":"g77Jx4DM","medianTextNegative":"a9H3puQ9","medianTextNeutral":"WdPiDx3F","labelText":"mFa9FqxE"};